import { Link, Stack, Typography } from "@mui/material"
import { FC } from "react"
import { useTranslation } from "react-i18next"

export const BROWSER_PRINT_DOWNLOAD_URL =
  "https://www.zebra.com/us/en/support-downloads/software/printer-software/browser-print.html"
export const BROWSER_PRINT_SSL_URL = "https://localhost:9101/ssl_support"

/** The numbered install steps; text lives in `browserPrintStep<n>.*`. */
const STEPS = [1, 2, 3, 4, 5] as const

export const BrowserPrintSetupSteps: FC = () => {
  const { t } = useTranslation()
  const origin = typeof window !== "undefined" ? window.location.origin : ""

  return (
    <Stack component="ol" spacing={1.5} sx={{ pl: 2.5, m: 0 }}>
      {STEPS.map((n) => (
        <li key={n}>
          <Typography variant="body2" fontWeight={700}>
            {t(`browserPrintStep${n}.title`)}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            {t(`browserPrintStep${n}.body`, { origin })}
          </Typography>
          {n === 1 && (
            <Link
              href={BROWSER_PRINT_DOWNLOAD_URL}
              target="_blank"
              rel="noopener noreferrer"
              variant="body2"
            >
              {t("browserPrintDownloadLink")}
            </Link>
          )}
          {n === 3 && (
            <Link
              href={BROWSER_PRINT_SSL_URL}
              target="_blank"
              rel="noopener noreferrer"
              variant="body2"
            >
              {BROWSER_PRINT_SSL_URL}
            </Link>
          )}
        </li>
      ))}
    </Stack>
  )
}
